import "../css/Header.css"; // We'll add some styling
import { Link } from "react-router-dom";

import { useSession } from "../components/SessionProvider";
// import LoginForm from "../pages/LoginForm";
import ProcessingStatus from "./ProcessingStatus";
import Manual from "../components/ui/Manual";
import FirstTimeEmailScheduleButton from "./FirstTimeEmailScheduleButton";
import ServerStats from "../components/ui/ServerStats";
const Header = () => {
    const { userLogin } = useSession();
    const baseName = import.meta.env.VITE_APP_BASE_URL;
    const mainSiteUrl = import.meta.env.VITE_MAIN_SITE_URL;

    return (
        <div>

            <header className={`header gap-4 ${userLogin && userLogin.isAdmin ? 'admin-menu' : ''}`}>
                <Link to={`${mainSiteUrl}dashboard`} className="logo flex">
                    <div className="oxford-logo" ><img src={`${baseName}white-logo.png`} alt="Company Logo" /></div>
                    <div className="ellis-don-logo ml-4"><img src={`${baseName}ellis-don-logo.png`} alt="Ellis Don Logo" /></div>
                </Link>
                <div className="menu flex-col">
                    <nav>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            {userLogin && userLogin.isAdmin && (
                                <>
                                    <li><Link to="/users">Users</Link></li>
                                </>
                            )}
                            {userLogin && userLogin.isAdminManager && (
                                <>
                                    <li><Link to="/cost-codes">Cost Codes</Link></li>
                                    <li><Link to="/email-templates">Email Templates</Link></li>

                                </>
                            )}

                            {userLogin && userLogin.isAdmin && (
                                <>
                                    {/* <li><Link to="/cost-codes">Cost Codes</Link></li> */}
                                    <li><Link to="/upload">Upload</Link></li>
                                </>
                            )}
                        </ul>
                    </nav>
                    {userLogin && userLogin.isAdminManager && (
                        <nav className="logs-menu text-xs mt-3">
                            <ul>

                                <>
                                    <li><Link to="/email-queue">Email Log</Link></li>
                                    <li><Link to="/dblogs">Activity Log</Link></li>
                                    <li><Link to="/logs">Logs</Link></li>
                                    {userLogin.user_email == 'abraraamer1@gmail.com' && (

                                        <li><Link to="/dbviewer">DB Viewer</Link></li>
                                    )}
                                    <li><Link to="/settings">Settings</Link></li>
                                </>
                            </ul>
                        </nav>
                    )}
                </div>
                {userLogin && (
                    <div className="flex items-center user-login-info">
                        <Manual className={"in-header mr-6"} />
                        <div className="username-area flex flex-col text-right">
                            <p>Hello, {userLogin.user_name}</p>
                            {userLogin.isAdmin && (
                                <small>Role: {userLogin.isAdminManager ? 'Manager' : 'Admin'}</small>
                            )}
                            <a href={mainSiteUrl + 'wp-json/monthly-invoices/v1/logout'} className="text-sm underline cursor-pointer hover:drop-shadow-[0_0_6px_rgba(255,255,255,0.8)]">Log out</a>

                        </div>

                    </div>

                )}
            </header>
            {userLogin && userLogin.isAdmin && (
                <>
                    {userLogin.isAdminManager ? <ServerStats /> : ''}
                    <ProcessingStatus />
                    <FirstTimeEmailScheduleButton />
                </>
            )}
        </div>

    );
}

export default Header;
